module.exports = __webpack_public_path__ + "static/media/centrifuge-top-empty.342c82ef.svg";